<mat-drawer-container class="mat-drawer-container">
    <mat-drawer #drawer position="end">
        <app-table-config-form [columns]="TableColumnsSorted$ | async"
                               [selectedColumns]="selectedColumns$ | async"
                               (selectedColumnsChange)="selectedColumnsChange($event)"
        ></app-table-config-form>
    </mat-drawer>
    <mat-drawer-content>
<section class="wrapper">
    <header class="header">
        <fa-icon class="icon" icon="file-contract"></fa-icon>
        <div class="dark-theme title">
            <h3 class="heading">{{ commissionsLabel$ | async }}</h3>
        </div>
        <span class="spacer" *ngIf="!searchVisible"></span>
        <mat-form-field appearance="standard" *ngIf="searchVisible" class="search-form" (click)="$event.stopPropagation()">
            <!--            <mat-label>Suche</mat-label>-->
            <input matInput type="search" placeholder="Suche" (keydown.Space)="$event.stopImmediatePropagation()" [formControl]="searchForm" #searchInput />
            <button *ngIf="searchForm.value" mat-icon-button aria-label="Clear" matSuffix (click)="searchForm.setValue('')">
                <fa-icon icon="times" class="clear-search-suffix"></fa-icon>
            </button>
        </mat-form-field>
        <button app-round-button [Active]="searchVisible" matTooltip="Suche" aria-label="Suche" (click)="onSearchBtnClick()"><fa-icon icon="search"></fa-icon></button>
    </header>

    <div class="wrapper">
        <mat-tab-group class="tab-group">
            <mat-tab *ngFor="let tab of Tabs$ | async">
                <ng-template mat-tab-label
                    >{{ tab.label }} &nbsp; <span *ngIf="(tab.dataSource$ | async)?.filteredData as data"> <ng-container *ngIf="data">({{ data.length }})</ng-container></span></ng-template
                >
                <ng-container
                    [ngTemplateOutlet]="tableTemplate"
                    [ngTemplateOutletContext]="{
                        dataSource$: tab.dataSource$,
                        loading$: tab.loading$,
                        displayedColumns: tab.displayedColumns,
                        drawer: drawer, customCellTemplates$: customCellTemplates$ | async,
                    }">
                </ng-container>
            </mat-tab>
        </mat-tab-group>
    </div>
</section>
<ng-template
    let-dataSource$="dataSource$"
    let-loading$="loading$"
    let-displayedColumns="displayedColumns"
    let-drawer="drawer"
    #tableTemplate>

    <ng-container *ngIf="(entitiesFetched$ | async) && !(loading$ | async); else loading">
        <div class="clickable-list-container scrollbar" *ngIf="(dataSource$ | async)?.data.length > 0">
            <table
                *ngIf="Columns"
                cdkDropList
                cdkDropListOrientation="horizontal"
                (cdkDropListDropped)="drop($event)"
                mat-table class="full-width-table"
                [dataSource]="dataSource$ | async"
                matSort
                #matSort="matSort"
                (matSortChange)="SortTableData($event, dataSource$, matSort)"
            >
                <ng-container matColumnDef="settingsButton">
                    <th mat-header-cell *matHeaderCellDef style="text-align: right;">
                        <button class="settings-button" mat-icon-button [matBadge]="disabledColumns$ | async" matTooltip="Tabelle anpassen" matTooltipPosition="left" (click)="drawer.toggle()">
                            <fa-icon icon="cog"></fa-icon>
                        </button>

                    </th>
                    <td mat-cell *matCellDef="let rowData">
                        <div class="table-cell-wrapper" style="text-align: right;">
                            <fa-icon icon="chevron-right"></fa-icon>
                        </div>
                    </td>
                </ng-container>
                <ng-container *ngFor="let column of filteredColumnsCustom" [matColumnDef]="column.name">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef class="drag-header" cdkDrag>
                    <div>
                            {{ column.header }}
                        </div>
                        </th>
                    <td mat-cell *matCellDef="let rowData">
                        <div>
                            <ng-container *ngIf="column.name === 'lastComment'">
                                <div class="cell-flex-wrapper" style="display: flex; align-items: center;">
                                    <button matTooltip="Kommentare schreiben" (click)="onCommentClick(rowData.id); $event.stopPropagation()" app-round-button>
                                        <fa-icon [icon]="CommentIcon"></fa-icon>
                                    </button>
                                    <app-loading [Size]="24" *ngIf="!(commentsFetched$ | async)" style="margin-left: 8px;"></app-loading>

                                    <div *ngIf="rowData.lastComment$ | async as html" style="display: flex; flex-direction: row; align-items: center; margin-left: 8px;">
                                        <div [innerHtml]="html" class="comment-line"></div>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="column.name === 'offerSum'">
                                <div class="cell-flex-wrapper" style="display: flex; align-items: center;">
                                    <app-loading [Size]="24" *ngIf="!(ledgerImportsFetched$ | async)" style="margin-left: 8px;"></app-loading>
                                    <div *ngIf="rowData.offerSum$ | async" style="margin-left: 8px;">
                                        {{ rowData.offerSum$ | async }}
                                    </div>
                                </div>
                            </ng-container>


                            <ng-container *ngIf="column.name.startsWith('roleId_')">
                                <div class="cell-flex-wrapper" style="display: flex; align-items: center;">
                                    <button (click)="OpenUserSelect(rowData.id); $event.stopPropagation()" app-round-button>
                                        <fa-icon icon="user-cog"></fa-icon>
                                    </button>
                                    <div class="three-line" style="margin-left: 8px;">
                                        {{ rowData.roleCols[column.name] }}
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="column.name !== 'lastComment' && column.name !== 'offerSum' && column.name !== 'roleCols'">
                        <div>
                                {{ rowData[column.name] }}
        </div>
                </ng-container>
                        </div>
                    </td>
                </ng-container>

                <ng-container *ngFor="let column of filteredColumnsDate" [matColumnDef]="column.name">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ column.header }}</th>
                    <td mat-cell *matCellDef="let rowData">
                        <div>
                            {{ rowData[column.name] | date }}
                        </div>
                    </td>
                    <td mat-cell *matCellDef="let rowData"></td>
                </ng-container>

<!--                <ng-container matColumnDef="chevron">-->
<!--                    <th mat-header-cell *matHeaderCellDef style="width: 30px"></th>-->
<!--                    <td mat-cell *matCellDef="let rowData">-->
<!--                        <div class="table-cell-wrapper">-->
<!--                            <fa-icon icon="chevron-right"></fa-icon>-->
<!--                        </div>-->
<!--                    </td>-->
<!--                </ng-container>-->

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                    mat-row
                    *matRowDef="let rowData; columns: displayedColumns"
                    [routerLink]="rowData.RouterLink"
                    routerLinkActive="active"
                    class="app-clickable-background"
                    [style]="'--app-clickable-background-color: ' + rowData.backgroundColor"
                    [class.mat-table-color-bar-highlight]="!!rowData.colorBarValue"
                    [ngStyle]="{ '--color-bar-value': rowData?.colorBarValue }"
                    [matTooltip]="rowData.tooltip"
                ></tr>
            </table>
        </div>
        <table  class="full-width-table"   *ngIf="!((dataSource$ | async)?.data.length > 0)">
            <tr>
                <td class="empty-table-text">Keine {{ commissionsLabel$ | async }} vorhanden</td>
            </tr>
        </table>
    </ng-container>
</ng-template>
<ng-template #loading>
    <app-loading></app-loading>
</ng-template>


    </mat-drawer-content>
</mat-drawer-container>
